var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1769,
    height: 967,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2259,
    y: 1329,
    width: 1769,
    height: 967
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2259 -1329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2265.5 1582.49C2265.5 1570.35 2275.35 1560.5 2287.49 1560.5L4001.51 1560.5C4013.65 1560.5 4023.5 1570.35 4023.5 1582.49L4023.5 2267.51C4023.5 2279.65 4013.65 2289.5 4001.51 2289.5L2287.49 2289.5C2275.35 2289.5 2265.5 2279.65 2265.5 2267.51Z",
    stroke: "#BFBFBF",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2989.4 1462)"
  }, "is", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.656,
    y: 0
  }, "a doctor."), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -619.94,
    y: 244
  }, "He"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -521.398,
    y: 244
  }, ": 61.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M2369.46 1711.72 2468.46 1711.72 2468.46 1715.72 2369.46 1715.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2369.46 1825)"
  }, "She", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 147.813,
    y: 0
  }, ": 23.2%")), /*#__PURE__*/React.createElement("path", {
    d: "M2369.46 1830.72 2517.46 1830.72 2517.46 1834.72 2369.46 1834.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2369.46 1944)"
  }, "It", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 98.5418,
    y: 0
  }, ": 0.5%")), /*#__PURE__*/React.createElement("path", {
    d: "M2369.46 1949.72 2468.46 1949.72 2468.46 1953.72 2369.46 1953.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2369.46 2063)"
  }, "I", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 49.271,
    y: 0
  }, ": 0.2%")), /*#__PURE__*/React.createElement("path", {
    d: "M2369.46 2068.72 2418.46 2068.72 2418.46 2072.72 2369.46 2072.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 2369.46 2183)"
  }, "Paul", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.1% ")), /*#__PURE__*/React.createElement("path", {
    d: "M2369.46 2188.72 2566.46 2188.72 2566.46 2192.72 2369.46 2192.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2504 1464 2889.29 1464",
    stroke: "#000000",
    strokeWidth: 10.3125,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 1706)"
  }, "One", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 147.813,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 1711.72 3417.31 1711.72 3417.31 1715.72 3269.31 1715.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 1825)"
  }, "David", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 1830.72 3392.31 1830.72 3515.31 1830.72 3515.31 1834.72 3392.31 1834.72 3269.31 1834.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 1944)"
  }, "There", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 246.354,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 1949.72 3392.31 1949.72 3515.31 1949.72 3515.31 1953.72 3392.31 1953.72 3269.31 1953.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 2063)"
  }, "Jack", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.1%")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 2068.72 3367.81 2068.72 3466.31 2068.72 3466.31 2072.72 3367.81 2072.72 3269.31 2072.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 83,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 3269.31 2183)"
  }, "John", /*#__PURE__*/React.createElement("tspan", {
    fill: "#A6A6A6",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 197.084,
    y: 0
  }, ": 0.1% ")), /*#__PURE__*/React.createElement("path", {
    d: "M3269.31 2188.72 3367.81 2188.72 3466.31 2188.72 3466.31 2192.72 3367.81 2192.72 3269.31 2192.72Z",
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.a90c00e97d2589af51c32a3309b0aeb8.svg";
export { ForwardRef as ReactComponent };